﻿import onReady from '../utils/onReady';
import * as Events from '../utils/events';
import domIterator from '../utils/domIterator';
import * as formError from '../utils/formError';
import { delegateEvent } from '../utils/events';


/**
 *
 * @param {HTMLElement} container
 * @constructor
 */
class Basket {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.
        onReady(() => this.init(container));
    }


    addEvents() {

        if (this.dom.submitButton !== null) {
            Events.addEvent(this.dom.container.querySelector("form"), "submit", e => {
                e.preventDefault();
                this.submit();
            });
        }

        delegateEvent(".deleteSectionBtn", "click", (ev) => {
            ev.event.preventDefault();

            let sectionid = ev.target.getAttribute("data-sectionid");
            let journalid = ev.target.getAttribute("data-journalid");
            let leasetypeid = ev.target.getAttribute("data-leasetypeid");

            this.dom.submitDeleteSectionID.value = sectionid;
            this.dom.submitDeleteJournalID.value = journalid;
            this.dom.submitDeleteLeaseTypeID.value = leasetypeid;

            let form = this.dom.container.querySelector("form");
            form.setAttribute("action", "/api/sitecore/signup/DeleteBasketEntry");
            form.submit();

        });


    }

    /**
     * Check if floors are correctly chosen
     *
     */
    floorCheck() {
        let floorVal = [],
            errorFlag = false;

        domIterator(this.dom.floorSelects, (element, index) => {
            floorVal.push(element.value);

            /*jshint bitwise: false*/
            floorVal[index] = ~~floorVal[index]; // Convert string to number
            /*jshint bitwise: true*/
        });

        if (floorVal.length !== 0) {

            // Loop through values, and increment by 2, since they come in pairs
            for (let i = 0; i < floorVal.length; i += 2) {

                // If one is set, but the other isn't, show error
                // If 'Fra' is higher than 'Til', show error
                if (floorVal[i] > 0 && floorVal[i + 1] < 1 || floorVal[i] < 1 && floorVal[i + 1] > 0) {
                    formError.addErrorClass(this.dom.floorSelects[i], "Vælg både 'Fra' og 'Til'", "change");
                    errorFlag = true;
                } else if (floorVal[i] > floorVal[i + 1]) {
                    formError.addErrorClass(this.dom.floorSelects[i], "'Fra' kan ikke være større end 'til'", "change");
                    errorFlag = true;
                }
            }
        }

        return errorFlag;
    }

    submit() {
        if (this.floorCheck()) { return; }
        else {
            this.dom.container.querySelector("form").submit();
        }
    }


    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {
        this.dom = {
            container // ES6 allows this syntax instead of writing "container: container"
        };

        // Put your other DOM-specific initializations here, and get your class moving!

        this.dom.floorSelects = this.dom.container.querySelectorAll(".form-basket__select");
        this.dom.submitButton = this.dom.container.querySelector(".buttonSubmit");


        this.dom.submitDeleteJournalID = this.dom.container.querySelector("#SubmitDeleteJournalID");
        this.dom.submitDeleteSectionID = this.dom.container.querySelector("#SubmitDeleteSectionID");
        this.dom.submitDeleteLeaseTypeID = this.dom.container.querySelector("#SubmitDeleteLeaseTypeID");

        this.dom.deleteSectionBtns = this.dom.container.querySelectorAll(".deleteSectionBtn");

        this.addEvents();

    }
}


export default Basket;
